import React, { useCallback, useState } from "react";
import { I18n, translate } from "@td/shared_utils";
import { useMutation } from "@apollo/client";
import CREATE_PRACTICE_TEAM from "../../mutations/create_practice_team.graphql";
import toastr from "../../../toastr";
import {teamNameMaxLength} from "../../constants";

const PracticeTeamNew = () => {
  const [errors, setErrors] = useState([]);
  const [teamName, setTeamName] = useState("");

  const [createPracticeTeam, { loading }] = useMutation(CREATE_PRACTICE_TEAM, {
    onCompleted: (data) => {
      const { practiceTeamId, errors } = data.tasCreatePracticeTeam;

      if (errors.length) {
        setErrors(errors);
      } else {
        window.location.replace(
          Routes.practice_team_path(practiceTeamId)
        );
      }
    },
    onError: () => {
      toastr.error(
        translate(null, "practice_team", "server_error")
      );
    },
  });

  const handleChange = useCallback((event) => {
    setTeamName(event.target.value);
  }, []);

  const handleSubmit = useCallback(() => {
    createPracticeTeam({
      variables: {
        name: teamName,
      }
    });
  }, [teamName]);

  return (
    <div>
      <h2>
        <I18n scope="practice_team.form" text="create" />
      </h2>
      <div className="section editable_module" id="person_account_information">
        {errors.map((error, index) => {
          return (
            <div
              key={index}
              className="error"
              data-testid="practice-team-error"
            >
              {error}
            </div>
          )}
        )}
        <table className="fields">
          <tbody>
            <tr>
              <th>
                <label
                  htmlFor="practice_team_nm"
                  data-testid="practice-team-name-label"
                >
                  <I18n scope="practice_team.fields" text="name" />
                  <span className="required_asterisk">*</span>
                </label>
              </th>
              <td>
                <input
                  autoFocus
                  id="practice_team_nm"
                  name="practice_team_nm"
                  data-testid="practice-team-name-input"
                  type="text"
                  onChange={handleChange}
                  maxLength={teamNameMaxLength}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <button
          disabled={loading}
          className="button"
          onClick={handleSubmit}
          data-testid="practice-team-submit-button"
        >
          <I18n scope="practice_team.actions" text={loading ? "saving" : "save"} />
        </button>
      </div>
    </div>
  );
};

export default PracticeTeamNew;
